import { ReportFilters } from 'domain/entity/reportFilters';
import getGenericUseCase from 'use-case/genericUseCase';

const readReportFiltersUseCase = getGenericUseCase<ReportFilters, null>((client, criteria) => client(criteria));

export default readReportFiltersUseCase;
